import { render, staticRenderFns } from "./SearchWithText.vue?vue&type=template&id=5daaf4fc&"
import script from "./SearchWithText.vue?vue&type=script&lang=js&"
export * from "./SearchWithText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports